import * as React from 'react';
import { ToneRowOptionsPrivilage, ToneRowComponent, ToneRowOptionsPrivilageImpl } from '../../../toolkit/toneoptions/tone/tonerowcomponent';
import { PaginationListViewModelImpl } from '../../../toolkit/verticallist/paginationverticallist/paginationlistviewmodel';
import { ToneDto } from '../../../../core/dto/tonedto';
import { EnglishToneRowCSSStyle } from '../../../toolkit/toneoptions/tone/englishtonerowcss';
import { BaseContext } from '../../../../utils/basecontext';
import { PlaylistEnglishToneRowCSSStyleImpl } from './englishtonerowcss';


export class PlaylistDetailsToneRowOptionsPrivilageImpl extends ToneRowOptionsPrivilageImpl
{
    constructor()
    {
        super();
        
        this.setLike(true);
        this.setPlay(true);
    }
}

export class PlaylistDetailsToneViewModelImpl extends PaginationListViewModelImpl<ToneDto>
{
    private cssStyle: EnglishToneRowCSSStyle;
    private privilage: ToneRowOptionsPrivilage;

    constructor(offset: number, context: BaseContext)
    {
        super(offset, context);

        this.cssStyle =  new PlaylistEnglishToneRowCSSStyleImpl(context);

        this.privilage = new PlaylistDetailsToneRowOptionsPrivilageImpl();
    }

    getView(t: ToneDto, position: number): boolean | JSX.Element 
    {
        return <ToneRowComponent onTuneSettingsAdded={()=>{}} onDeleteClicked={(toneDto: ToneDto) =>{this.deleteData(toneDto.getId());}}  toneRowOptionsPrivilage={this.privilage} cssStyle={this.cssStyle} key={position}  context={this.getContext()} toneDto={t}  position={position}/>;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/playlistdetails/playlistdetailsviewmodel.tsx